import * as React from 'react'

const defaultSize = {
  x: 32,
  y: 32,
}

export interface IProps {
  size?: { x: number; y: number }
  style?: React.CSSProperties
}
export const FrameDone: React.FCC<IProps> = ({ size = defaultSize, style }) => (
  <svg
    width={size.x}
    height={size.y}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 22L10 24H11V22H14V21H11L11 11H21L21 16L22 16L22 11H24V10H22L22 8H21L21 10H11V8H10L10 10H8V11H10L10 21H8V22H10ZM19.3536 23.8536L24.8536 18.3536L24.1464 17.6464L19 22.7929L16.3536 20.1464L15.6464 20.8536L18.6464 23.8536L19 24.2071L19.3536 23.8536Z"
      fill="var(--figma-color-text, rgba(0, 0, 0, 0.8))"
    />
  </svg>
)
